export default "__VITE_ASSET__935d5c1b__"